// extracted by mini-css-extract-plugin
export var filterIncDec = "_42-0";
export var leftBorder = "_42-1";
export var rightBorder = "_42-2";
export var stringInput = "_42-3";